import { Getter } from "vuex";
import { IState } from "./state";

const title: Getter<IState, IState> = (state) => state.title;
const preamble: Getter<IState, IState> = (state) => state.preamble;
const searchResult: Getter<IState, IState> = (state) => state.searchResult;
const hits: Getter<IState, IState> = (state) => state.searchResult.searchHits;
const templateFilter: Getter<IState, IState> = (state) => state.templateFilter;
const showMore: Getter<IState, IState> = (state) => {
  //Kolla på summan av sidor på aktiva filters
  // if amountOfShowingHits < den summan
  let sum = 0;
  let showingHits = state.currentlyShowingHits;
  Object.keys(showingHits).forEach((key) => {
    sum += showingHits[key].length;
  });
  return state.amountOfShowingHits < sum;
};
const totalHits: Getter<IState, IState> = (state) =>
  state.searchResult.totalHits;
const showingHits: Getter<IState, IState> = (state) =>
  state.searchResult.searchHits.length;
const query: Getter<IState, IState> = (state) => state.query;
const shouldFocus: Getter<IState, IState> = (state) => state.focus.shouldFocus;
const focusIndex: Getter<IState, IState> = (state) => state.focus.index;
const hitsPerPage: Getter<IState, IState> = (state) => state.hitsPerPage;
const searchedQuery: Getter<IState, IState> = (state) => state.searchedQuery;
const suggestion: Getter<IState, IState> = (state) => state.suggestion;
const translations: Getter<IState, IState> = (state) => state.translations;
const currentPage: Getter<IState, IState> = (state) => state.currentPage;
const count: Getter<IState, IState> = (state) => state.count;
const amountOfShowingHits: Getter<IState, IState> = (state) =>
  state.amountOfShowingHits;
const currentlyShowingHits: Getter<IState, IState> = (state) =>
  state.currentlyShowingHits;

export default {
  title,
  preamble,
  searchResult,
  hits,
  templateFilter,
  showMore,
  totalHits,
  showingHits,
  query,
  shouldFocus,
  hitsPerPage,
  focusIndex,
  searchedQuery,
  suggestion,
  translations,
  currentPage,
  amountOfShowingHits,
  count,
  currentlyShowingHits,
};
